import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable, of } from "rxjs";
import { GenderService } from "../../shared/services/gender.service";
import { GenderResponse } from "../../shared/models/gender.model";

@Injectable({
    providedIn: 'root',
})
export class GetGenderResolver implements Resolve<GenderResponse[]> {

    constructor(
        private genderService: GenderService,
    ) { }

    resolve(): Observable<GenderResponse[]> {
        return this.genderService.getAll();
    }
}
